export enum WelcomePageActionsEnum {
    NEW_CONSENT = 'NEW_CONSENT',
    VIEW_CONSENTS = 'VIEW_CONSENTS',
    RESUME_CONSENT = 'RESUME_CONSENT',
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    EXPORT_DATA = 'EXPORT_DATA',
    SETTINGS = 'SETTINGS',
    CMS_INDICATIONS = 'CMS_INDICATIONS',
    CMS_IMAGES = 'CMS_IMAGES',
    ORGANIZATION_MANAGEMENT = 'ORGANIZATION_MANAGEMENT',
    MEDICATION_MANAGEMENT = 'MEDICATION_MANAGEMENT'
}
